import { DraftFutureLeg } from '#/unified-rfqs/ui/rfq-builder/types';
import { UnifiedInstruments } from '#/unified-rfqs/ui/instruments/types';
import { areExpirationsEqual } from './expiration-utils';

export default function greeksView(
  expiration: DraftFutureLeg['expiration'],
  instruments: UnifiedInstruments['futureInstruments'],
) {
  const instrument = instruments.find((ins) =>
    areExpirationsEqual(ins.expiration, expiration),
  );
  return instrument?.greeks;
}
